import type { RequestBuilder } from "@lernetz/request";
import { processIn, processOut } from "./process";

export class Gateway {
  base: RequestBuilder;
  in: (data: any) => any;
  out: (data: any) => any;

  constructor(config: Partial<Gateway>) {
    Object.assign(this, { in: processIn, out: processOut, ...config });
  }
}
